import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../sections/Hero";
import { NextConcert } from "../sections/NextConcert";
import { Lineup } from "../sections/Lineup";
import { PastEvents } from "../sections/PastEvents";
import { Marquee } from "../sections/Marquee";
import { Experience } from "../sections/Experience";
import { Venue } from "../sections/Venue";
import { Packages } from "../sections/Packages";
import { Signup } from "../sections/Signup";
import { Sponsors } from "../sections/Sponsors";
import { FAQ } from "../sections/FAQ";
import { fetchConcerts, fetchSponsors } from "../lib/api";
import { scrollToId } from "../lib/scroll";

export default function Home() {
  const [concerts, setConcerts] = useState([]);
  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(true);
  const { hash } = useLocation();

  useEffect(() => {
    fetchConcerts().then(setConcerts).catch(() => setConcerts([])).finally(() => setLoading(false));
    fetchSponsors().then(setSponsors).catch(() => setSponsors([]));
  }, []);

  useEffect(() => {
    if (!hash || loading) return;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 150);
    return () => clearTimeout(t);
  }, [hash, loading]);

  const next = concerts.find((c) => !c.is_past);

  return (
    <main data-testid="home-page">
      <Hero />
      <NextConcert concert={next} />
      <Lineup concerts={concerts} loading={loading} />
      <PastEvents concerts={concerts} />
      <Marquee />
      <Experience />
      <Venue />
      <Packages />
      <Signup />
      <Sponsors sponsors={sponsors} />
      <FAQ />
    </main>
  );
}
